import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';
import Layout from './layout';
import Home from './views/home';
import RegistrationForm from './components/registration.form';
import HandleSpainActivityBooking from './components/booking/handlespainactivity.booking';
import HandleCompetitionBooking from './components/booking/handlecompetition.booking';

import GoogleSheetsService from './service/googlesheet.service';
import AppSettingsService from './service/appsettings.service';

const App = () => {
    const [loading, setLoading] = useState(true);
    const [reCAPTCHAActive, setReCAPTCHAActive] = useState(false);
    const [registrationStatus, setRegistrationStatus] = useState({
        spainCompetitions: 0,
        summerTourCompetitions: 0,
        activities: 0
    });
    const isProduction = process.env.NODE_ENV === 'production';

    useEffect(() => {
        var getReCAPTCHAActive = AppSettingsService.getReCAPTCHAActive();
        var getCompetitionStatus = GoogleSheetsService.getRegistrationStatus();

        Promise.all([getReCAPTCHAActive, getCompetitionStatus]).then((result) => {
            if (result !== null) {
                //This is tmp solution to remove summer tour from the main select view
                //I decided to keep the code as is as to be able to revert easily
                result[1].summerTourCompetitions = 0;

                setReCAPTCHAActive(result[0]);
                setRegistrationStatus(result[1]);
                setLoading(false);
            }
        });
    }, []);

    if (loading === false) {
        return (
            <BrowserRouter>
                <Switch>
                    <Layout>
                        <Route exact path='/' component={() => { return (<h3 className='s4g-select-competition-type-header'>Här finns inget... :)</h3>) }} />
                        <Route exact path='/spain' component={() => { return (<Home reCAPTCHAActive={reCAPTCHAActive} registrationStatus={registrationStatus} />) }} />
                        <Route exact path='/summertour' component={() => { return (<RegistrationForm competitionType={2} reCAPTCHAActive={reCAPTCHAActive} goBack={false} />) }} />
                        <Route exact path='/spain/competition/mybooking' component={() => { return (<HandleCompetitionBooking competitionType={1} reCAPTCHAActive={reCAPTCHAActive} />) }} />
                        <Route exact path='/spain/activity/mybooking' component={() => { return (<HandleSpainActivityBooking reCAPTCHAActive={reCAPTCHAActive} />) }} />
                        <Route exact path='/summertour/mybooking' component={() => { return (<HandleCompetitionBooking competitionType={2} reCAPTCHAActive={reCAPTCHAActive} />) }} />
                    </Layout>
                </Switch>
            </BrowserRouter>
        );
    } else {
        return (
            <Layout>
                <CacheBuster
                    currentVersion={version}
                    isEnabled={isProduction} 
                    isVerboseMode={false} 
                    metaFileDirectory={'.'} 
                >
                </CacheBuster>
                    {window.location.href.includes('mybooking') === false && <h3 className='s4g-select-competition-type-header'>Laddar sidan, vänligen vänta lite...</h3>}
                    {window.location.href.includes('mybooking') === true && <h3 className='s4g-select-competition-type-header'>Hämtar din bokning, vänligen vänta lite...</h3>}
            </Layout>
        );
    }
}

export default App;
